<template>
  <div class="d-flex">
    <font-awesome-icon
      v-if="icon"
      :icon="['fas', icon]"
      size="lg mr-3"
    />
    <div>
      <h5 class="font-weight-semi-bold mb-2">
        {{ title }}
      </h5>
      <ul
        v-if="children.length"
        class="at-glance-children-list"
      >
        <li
          v-for="child in children"
          :key="`${title}-${child.slug}`"
          class="at-glance-child"
        >
          <NuxtLink
            v-if="child && slug !== 'certification'"
            :to="generateURL(child.slug)"
          >
            {{ child.name }}
          </NuxtLink>
          <span v-else>
            {{ child.name }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    children: {
      type: Array,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
  },
  methods: {
    generateURL(childSlug) {
      const updatedCollectionSlug = this.slug.replace('_', '-');
      return `/collections/${updatedCollectionSlug}/${childSlug}/`;
    },
  },
};
</script>

<style scoped>
.at-glance-children-list {
  margin-bottom: 0;
  padding-left: 0.875rem;
  font-size: 16px;
}

.at-glance-child::marker {
  font-size: 1.25rem;
  line-height: 1;
}
</style>
